export const stockStatus = {
  OUT_OF_STOCK: 'out of stock',
  IN_STOCK: 'in stock',
};
export const deviceType = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export const deviceBreakpoint = {
  // mobile is lower than 480px
  MOBILE: 480,
};

export const layoutMode = {
  FULL: 'full',
  HORIZONTAL_SCROLL: 'horizontal_scroll',
};

export const pageType = {
  CART_SIDEBAR: 'cart_sidebar',
};

export const defaultLayoutStyle = {
  desktop: layoutMode.FULL,
  mobile: layoutMode.FULL,
};

export const classes = {
  cartRelatedProducts: 'cart-related-products',
  cartRelatedProductsLoading: 'cart-related-products-loading',
  cartRelatedProductsList: 'cart-related-products-list',
  cartRelatedProductsHide: 'cart-related-products-hide',
  cartRelatedProductsHorizontalScroll:
    'cart-related-products-horizontal-scroll',
  hasCartRelatedProductsHorizontalScroll:
    'has-cart-related-products-horizontal-scroll',
};

export const e2eIds = {
  CONTENT: 'cart-sidebar-related-products_content',
  IMAGE: 'cart-sidebar-related-products_content--image',
  TITLE: 'cart-sidebar-related-products_content--title',
  PRICE: 'cart-sidebar-related-products_content--price',
};
